import { webApiBuildUrl } from '@api/utils'
import { fetchApi } from 'src/shared/lib/response-worker/model'
import { IShipAddress, ShipAddress } from '@entities/shipment/contract'

function getAddressByIdUrl(shipAddressId: number): string

function getAddressByIdUrl(shipAddressId: number) {
    return webApiBuildUrl(`api/order/addresses/addressId/${shipAddressId}`)
}

export async function getAddressById(shipAddressId: number) {
    const response = await fetchApi.get<IShipAddress>(getAddressByIdUrl(shipAddressId))
    return ShipAddress.check(response.data)
}

export { getAddressByIdUrl }
